export const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign"];

const STORAGE_KEY = "qd_utms";

const parseUtms = (search) => {
  const params = new URLSearchParams(search);
  const utms = {};
  UTM_PARAMS.forEach((key) => {
    if (params.get(key)) utms[key] = params.get(key);
  });
  return utms;
};

// Save UTMs from the URL for the rest of the session. A new set of UTMs
// replaces the old one entirely so values from different campaigns don't mix.
export const storeUtms = (search) => {
  const utms = parseUtms(search);
  if (Object.keys(utms).length === 0) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
  } catch (e) {
    // Storage blocked (e.g. privacy mode); the URL is still used directly
  }
};

// UTMs from the current URL if present, otherwise the ones saved this session
export const getUtms = (search) => {
  const utms = parseUtms(search);
  if (Object.keys(utms).length > 0) return utms;
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
};
